import { isAxiosError } from '@lib/state';

const START_OF_DAY_LOCK_ERROR_CODE = 'start_of_day_locked';
const START_OF_DAY_LOCK_ERROR_TYPE = 'StartOfDayLockedException';

export function isStartOfDayLockError(error: unknown): boolean {
  if (!isAxiosError(error)) return false;

  const status = error.response?.status;
  const errorCode = error.response?.data?.errorCode;
  const errorType = error.response?.data?.type;

  return (
    status === 400 &&
    (errorCode === START_OF_DAY_LOCK_ERROR_CODE || errorType === START_OF_DAY_LOCK_ERROR_TYPE)
  );
}
